import React, { useReducer, useEffect } from "react";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { Button, Modal } from "react-bootstrap";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../../config/toastNotification";
import BlockSuccessMessage from "../../errorMessages/BlockSuccessMessage";
import FormErrorMessage from "../../errorMessages/FormErrorMessage";
import axios from "../../../../config/axios";
import { initialState, manageMembersReducer } from "./manageMembersReducer";
import BlockErrorMessage from "../../errorMessages/BlockErrorMessage";
import CMSFormMultiSelect from "../../forms/CMSFormMultiSelect";

const AddMembers = ({ show, setShow, parentId, loadData, moduleConfig }) => {
  const [state, dispatch] = useReducer(manageMembersReducer, initialState);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const loadMembers = async () => {
    if (parentId) {
      try {
        const res = await axios.get(
          `${moduleConfig.url}/members-list-for-target/${parentId}`
        );
        dispatch({
          type: "FETCH_SUCCESS",
          payload: res.data,
        });
      } catch (error) {
        dispatch({
          type: "FETCH_FAILURE",
          payload: "Members loading failed.",
        });
      }
    }
  };

  useEffect(() => {
    if (show) {
      loadMembers();
    }
  }, [show]);

  const onSubmit = async (data, resetForm) => {
    dispatch({
      type: "FORM_SUBMISSION_REQUEST",
    });

    try {
      const res = await axios.post(
        `${moduleConfig.url}/add-members-in-target/${parentId}`,
        data
      ); //
      loadData();
      resetForm();
      handleClose();
      dispatch({
        type: "FORM_INITIAL_STAGE",
      });
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `Members added successfully.`,
        type: "success",
      });
    } catch (error) {
      dispatch({
        type: "FORM_SUBMISSION_FAILED",
        payload: error,
      });
      setTimeout(() => {
        dispatch({
          type: "FORM_INITIAL_STAGE",
        });
      }, 5000);
    }
  };
  return (
    <Formik
      initialValues={{
        memberIds: [],
      }}
      validationSchema={yup.object().shape({
        memberIds: yup.array().of(yup.string()).min(1, "Select Members"),
      })}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={true}
      onSubmit={async (values, { resetForm }) => {
        onSubmit(values, resetForm);
      }}
    >
      {(form) => (
        <Modal show={show} onHide={handleClose}>
          {(state.isLoading) && <div class="overlay">
            <i class="fas fa-2x fa-sync-alt text-white fa-spin"></i>
          </div>}

          {state.error && state.status === "fetchFailed" ? (
            <BlockErrorMessage error={state.error} />
          ) : (
            <>
              <Form onSubmit={form.handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title>Add Member(s)</Modal.Title>
                </Modal.Header>
                {state.status === "submitted" ? (
                  <Modal.Body>
                    <BlockSuccessMessage
                      heading="Done!"
                      message={`Members added successfully.`}
                    />
                  </Modal.Body>
                ) : (
                  <>
                    <Modal.Body>
                      {state.error && <FormErrorMessage error={state.error} />}


                      <CMSFormMultiSelect
                        name="memberIds"
                        label="Select Members"
                        required={true}
                        form={form}
                        options={state.data.items}
                        displayValue="fullName"
                      />

                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose}>
                        Close
                      </Button>
                      <Button variant="primary" type="submit">
                        Submit
                      </Button>
                    </Modal.Footer>
                  </>
                )}
              </Form>
            </>
          )}
        </Modal>
      )}
    </Formik>
  );
};

export default AddMembers;
